import React, {useCallback, useContext, useEffect, useState} from 'react';
import './TextSize.sass';
import {useSelector} from 'react-redux';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {Range} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/components/Range/Range';
import {selectEditorDisabled} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';

const MIN_FONT_SIZE = 16;
const MAX_FONT_SIZE = 300;

export const TextSize = () => {
  const {canvas} = useContext(EventCreateContext);
  const [value, setValue] = useState(0);
  const activeObjects = canvas?.getActiveObjects();
  const editorDisabled = useSelector(selectEditorDisabled);

  useEffect(() => {
    const updateFontSize = () => setValue(canvas?.getActiveObjects()?.[0]?.fontSize);

    updateFontSize();
    canvas?.on('object:reset', updateFontSize);

    return () => {
      canvas?.off('object:reset', updateFontSize);
    };
  }, [canvas, activeObjects]);

  const setNewValue = useCallback(
    (val) => {
      setValue(val);

      activeObjects?.forEach((obj) => {
        obj.fontSize = val;
      });

      canvas.requestRenderAll();
      canvas.fire('object:modified');
    },
    [canvas, activeObjects]
  );

  const changeTextSize = useCallback(
    (val) => {
      activeObjects?.forEach((obj) => {
        obj.fontSize = val;
      });

      canvas.requestRenderAll();
      canvas.fire('object:modified');
    },
    [canvas, activeObjects]
  );

  const onObjectScaled = useCallback(
    (event) => {
      if (event.action !== 'scale') {
        return;
      }

      const {target} = event;

      const changeFontSize = (obj) => {
        let fontSize = Math.floor((obj.fontSize *= target.scaleX));
        fontSize = fontSize < MIN_FONT_SIZE ? MIN_FONT_SIZE : fontSize;
        fontSize = fontSize > MAX_FONT_SIZE ? MAX_FONT_SIZE : fontSize;
        obj.fontSize = fontSize;
        obj.width *= target.scaleX;
        obj.height *= target.scaleY;
        obj.scaleX = 1;
        obj.scaleY = 1;
        setValue(obj.fontSize);
        canvas.requestRenderAll();
        canvas.fire('object:modified');
      };

      if (target?.type === 'activeSelection') {
        target.forEachObject(changeFontSize);
      } else if (target?.type === 'textbox') {
        changeFontSize(target);
      }
    },
    [canvas]
  );

  useEffect(() => {
    canvas?.on('object:modified', onObjectScaled);

    return () => {
      canvas?.off('object:modified', onObjectScaled);
    };
  }, [canvas, onObjectScaled]);

  return (
    <div className="create-flow__texteditor-content">
      <div className="create-flow__range textsize">
        <Range
          min={MIN_FONT_SIZE}
          max={MAX_FONT_SIZE}
          step="1"
          suffix=" pt"
          value={value}
          onChange={setNewValue}
          onLocalChange={changeTextSize}
          disabled={editorDisabled}
          dataQaId="step1-textsize-range"
          inputEditable
        />
      </div>
    </div>
  );
};
